/**
 * Login modal: countdown before enabling resend SMS (aligned with Auth::$timeout).
 *
 * @param {JQuery} modal
 * @return void
 */
function initLoginModalResendTimer(modal) {
    const modalEl = modal && modal.jquery ? modal : $('#commonModal');
    const wrap = modalEl.find('.login-resend-countdown');
    const btn = modalEl.find('#login-resend-code-button');
    const secEl = modalEl.find('.login-resend-seconds');
    const alignWrap = modalEl.find('.align-button-resend');

    if (!wrap.length || !btn.length || !secEl.length) {
        return;
    }

    const prevId = modalEl.data('loginResendIntervalId');
    if (prevId) {
        clearInterval(prevId);
    }

    let remaining = parseInt(wrap.attr('data-resend-timeout'), 10);
    if (!Number.isFinite(remaining) || remaining < 0) {
        remaining = 60;
    }

    btn.prop('disabled', true);
    wrap.show();
    alignWrap.removeClass('align-button-resend--countdown-hidden');

    const tick = function () {
        secEl.text(String(remaining));
        if (remaining <= 0) {
            wrap.hide();
            alignWrap.addClass('align-button-resend--countdown-hidden');
            btn.prop('disabled', false);

            return false;
        }

        return true;
    };

    tick();

    const intervalId = setInterval(function () {
        remaining--;
        if (!tick()) {
            clearInterval(intervalId);
            modalEl.removeData('loginResendIntervalId');
        }
    }, 1000);

    modalEl.data('loginResendIntervalId', intervalId);
}

$(document).on('click', '[data-ajax-popup]', function (e) {
    e.preventDefault();
    const item = $(this);
    const isButton = item.is('button[type="submit"], input[type="submit"]');
    const title = item.data('title');
    const method = item.data('method') || 'GET';
    const size = item.data('size') || 'uk-width-large';
    const url = item.attr('href') || item.data('url');
    const modal = $('#commonModal');

    modal.find('.loading').addClass('show');

    const handleResponse = (data) => {
        // jQuery auto-parses JSON, so only parse if it's still a string
        if (typeof data === 'string') {
            try {
                data = JSON.parse(data);
            } catch (e) {
                console.error('Ошибка при парсинге JSON:', e);
            }
        }

        const sizes = ['small', 'medium', 'large', 'xlarge', 'auto'];
        const modifiers = ['', '@s', '@m', '@l'];
        const widthClasses = [];

        sizes.forEach(size => {
            modifiers.forEach(mod => {
                widthClasses.push(`uk-width-${size}${mod}`);
            });
        });
        const dialog = document.querySelector('#commonModal [data-type="dialog"]');
        widthClasses.forEach(c => dialog.classList.remove(c));

        modal.find('[data-type="dialog"]').addClass(size);
        modal.find('[data-type="title"]').html(data.title || title);
        modal.find('[data-type="content"]').html(data.content || data);
        if (typeof data.updates !== "undefined") {
            for (let item in data.updates) {
                const html = data.updates[item];

                document.querySelectorAll(item).forEach((updateItem) => {
                    const tpl = document.createElement('template');
                    tpl.innerHTML = html.trim();
                    const newEl = tpl.content.firstElementChild;

                    if (tpl.content.childElementCount === 1 && newEl.matches(item)) {
                        // пришёл сам блок (например, span.buttons__personal_cabinet) — меняем целиком
                        updateItem.outerHTML = html;
                    } else {
                        // пришло только содержимое (например, для li в мобильном меню) — вставляем внутрь
                        updateItem.innerHTML = html;
                    }
                });
            }
        }

        // The mobile "account" popup panel only exists in the DOM when the
        // page was originally rendered for a logged-in visitor, so it's
        // missing for a visitor who just logged in via this modal.
        if (data.account_popup_mobile_html && !document.getElementById('account-popup-modal-mb')) {
            document.body.insertAdjacentHTML('beforeend', data.account_popup_mobile_html);
        }

        // Execute RetailRocket setCustomer if customer data is present
        if (data.customerData && typeof window.rrApiOnReady !== 'undefined') {
            const customer = data.customerData;
            window.rrApiOnReady.push(function() {
                try {
                    rrApi.setCustomer({
                        "customerId": String(customer.id),
                        "email": customer.email || '',
                        "phone": customer.phone || '',
                        "customData": {
                            "firstName": customer.firstName || '',
                            "lastName": customer.lastName || ''
                        },
                        "softLinks": [],
                        "isAgreedToReceiveMarketingMail": true
                    });
                } catch (e) {
                    console.error('rrApi.setCustomer error:', e);
                }
            });
        }

        initLoginModalResendTimer(modal);

        UIkit.modal(modal).show();
        modal.find('.loading').removeClass('show');

        if (data && data.customerData) {
            $(document).trigger('customer:login', [data.customerData]);
        }
    };

    const handleError = () => {
        modal.find('[data-type="title"]').html(title);
    };

    if (isButton) {
        const form = item.closest('form');
        if (form.length && url) {
            $.ajax({
                url,
                method: form.attr('method') || 'POST',
                data: form.serialize(),
                headers: {'x-secret': 'true'},
                success: handleResponse,
                error: handleError,
            });
        }
    } else if (url) {
        $.ajax({
            url,
            method,
            headers: {'x-secret': 'true'},
            success: handleResponse,
            error: handleError,
        });
    }

});
/**
 * Send register phone code
 */
$(document).on("click", "#button-get-sms-code", function () {
    let buttonSendRegisterCode = $("html").find("#button-get-sms-code");
    let url = buttonSendRegisterCode.attr("data-url");
    let method = "POST";
    let retryMessage = $(".retry-message");
    let retrySeconds = $(".retry-seconds");
    let seconds = $(".seconds");

    buttonSendRegisterCode.attr('disabled', true);

    $.ajax({
        url,
        method,
        headers: {'x-secret': 'true'},
        data: {
            phone: $('input[name="phone"]').val()
        },
        success: function (data) {
            if (data.success === false) {
                retryMessage.html(data.message || '');
                seconds.show();
                buttonSendRegisterCode.prop('disabled', false);
                return;
            }
            retryMessage.html(data.retry_message);
            retrySeconds.html(data.retry_seconds);
            seconds.show();
            const waitSeconds = parseInt(data.retry_seconds, 10);
            startCountdown(Number.isFinite(waitSeconds) && waitSeconds > 0 ? waitSeconds : 59);
        },
        error: function () {
            retryMessage.html('');
            retrySeconds.html('');
            seconds.show();
        },
    });

    /**
     * Timer for activating resend register code button
     * @param seconds
     */
    function startCountdown(seconds = 59) {
        let remaining = seconds;
        let $wrapper = $('.verify-sms-code-wrapper');
        let $retrySeconds = $wrapper.find('.retry-seconds');
        let $retryMessage = $wrapper.find('.retry-message');
        let $secondsSuffix = $wrapper.find('.seconds');

        $retryMessage.show();
        $retrySeconds.show();
        $secondsSuffix.show();

        $retrySeconds.text(remaining);

        let interval = setInterval(function () {
            remaining--;
            $retrySeconds.text(remaining + ' s.');

            if (remaining <= 0) {
                clearInterval(interval);

                $retryMessage.text('');
                $retrySeconds.hide();
                $secondsSuffix.hide();
                $('#button-get-sms-code').prop('disabled', false);
            }
        }, 1000);
    }
});

$(document).on('click', '#login-resend-code-button', function (e) {
    e.preventDefault();
    const btn = $(this);
    if (btn.prop('disabled')) {
        return;
    }

    const form = btn.closest('form');
    const modal = $('#commonModal');
    const url = btn.data('url');
    if (!form.length || !url) {
        return;
    }

    btn.prop('disabled', true);

    $.ajax({
        url,
        method: form.attr('method') || 'POST',
        data: form.serialize(),
        headers: {'x-secret': 'true'},
        success: function (data) {
            if (typeof data === 'string') {
                try {
                    data = JSON.parse(data);
                } catch (err) {
                    console.error('Ошибка при парсинге JSON:', err);
                }
            }

            if (data && data.updates) {
                for (let selector in data.updates) {
                    const el = document.querySelector(selector);
                    if (el) {
                        el.innerHTML = data.updates[selector];
                    }
                }

                return;
            }

            if (data && data.success === true) {
                const wrap = modal.find('.login-resend-countdown');
                const sec = parseInt(data.timeout, 10);
                if (Number.isFinite(sec) && sec > 0) {
                    wrap.attr('data-resend-timeout', sec);
                }
                initLoginModalResendTimer(modal);
            } else {
                btn.prop('disabled', false);
            }
        },
        error: function () {
            btn.prop('disabled', false);
        },
    });
});
